import { LOCAL_FONT_PROTOCOL } from "../FontMetadata";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

export const HanziPenSCFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LOCAL_FONT_PROTOCOL,
  },
];
